module.exports = __webpack_public_path__ + "img/r3.b5f20205.png";